<template>
  <div>
    <div v-for="conceptKey in Object.keys(aggregations)" :key="conceptKey">
      <div class="p-3">
        <h4 v-b-toggle="'aggredation_' + conceptKey">
          {{ conceptKey | translate(labels, 'servicelibrary_ServiceLibraryFilters') }}
          ({{ aggregations[conceptKey]._counter }})
          <b-icon class="float-right text-large" icon="caret-up" />
        </h4>

        <b-collapse :id="'aggredation_' + conceptKey"
                    :key="'aggredation_' + conceptKey + isfiltersWrapperOpen"
                    :visible="isfiltersWrapperOpen && (conceptKey in facetFilter) && facetFilter[conceptKey].length > 0"
        >
          <b-link v-if="(conceptKey in facetFilter) && facetFilter[conceptKey].length > 0"
                  class="d-block font-condensed"
                  :disabled="disabled"
                  @click="$emit('clear', conceptKey)"
          >
            {{ 'clearLabel' | translate(labels, 'shared_CommonFunctional') }}
          </b-link>

          <b-form-checkbox-group v-model="facetFilter[conceptKey]" stacked>
            <template v-for="(count, facet) in aggregations[conceptKey]">
              <b-form-checkbox v-if="facet !== '_counter'"
                               :key="'facet_' + facet"
                               :value="facet"
                               :disabled="!facetFilter[conceptKey].indexOf(facet) >= 0 && count === 0"
              >
                {{ conceptKey === 'locale_filter' ?
                  translateLocale(facet) : facet |
                  translateFallback(labels, 'servicelibrary_ServiceLibraryFacets') }}
                ({{ count }})
              </b-form-checkbox>
            </template>
          </b-form-checkbox-group>
        </b-collapse>
      </div>
      <hr class="m-0">
    </div>
  </div>
</template>

<script>
import langs from 'langs'

export default {
  conceptName: ['shared_CommonFunctional', 'servicelibrary_ServiceLibraryFilters'],
  props: {
    disabled: {
      type: Boolean
    },
    aggregations: {
      required: true
    },
    facetFilter: {
      required: true
    },
    isfiltersWrapperOpen: {
      type: Boolean
    }
  },
  data() {
    return {
      isExpanded: false,
      langs: langs
    }
  }
}
</script>

<style scoped lang="scss">
  h4 {
    span {
      transition: .2s transform;
    }
    &.collapsed {
      span {
        transform: rotate(180deg);
      }
    }
  }
</style>
